module.exports = __webpack_public_path__ + "static/media/parent-icon.ebe348a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/parent-icon.png
// module id = 1798
// module chunks = 0